import React, { useEffect, useState } from 'react';
import {
	View,
	StyleSheet,
	ScrollView,
	Dimensions,
	Platform,
} from 'react-native';
import I18n from '../../../components/shared/i18n/I18n.component';
import FieldBuilder from '../../../components/shared/FieldBuilder/FieldBuilder';
import SolidButtonContainer from '../../../components/shared/Buttons/SolidButton.container';
import useDevicePlatform, {
	DeviceType,
} from '../../../hooks/useDevicePlatform.hook';
import colors from '../../../config/colors';

export const TWO_FACTOR_AUTH_FIELD = 'twoFactorRequired';
export const TWO_FACTOR_AUTH_DEFAULT = false;

const twoFactorAuthOptions = [
	{ label: 'general.must', value: true },
	{ label: 'general.NotMust', value: false },
];

interface Props {
	data: any;
	disableSubmit: boolean;
	setDisableSubmit: any;
	eventsOptions: string[];
	onUpdate(data: string[]): void;
	onCancel(): void;
	canNotEdit?: boolean;
}

export const General = ({
	eventsOptions,
	onCancel,
	onUpdate,
	disableSubmit,
	setDisableSubmit,
	canNotEdit,
}: Props) => {
	const platform = useDevicePlatform();

	const isWeb = platform === DeviceType.WEB;
	const [isActive, setIsActive] = useState(true);

	useEffect(() => {
		setIsActive(!canNotEdit);
	}, [canNotEdit]);

	return (
		<ScrollView
			style={{ paddingHorizontal: 20, marginTop: 20 }}
			contentContainerStyle={styles.container}
		>
			<View style={styles.body}>
				<View style={isWeb ? styles.row : styles.mobileRow}>
					<View style={isWeb ? undefined : { width: '100%' }}>
						<I18n
							size={16}
							weight='normal'
							style={isWeb ? styles.text : undefined}
						>
							businessSettings.general.twoFactorAuth
						</I18n>
						<I18n
							size={12}
							weight='normal'
							style={[
								{ paddingBottom: 20, paddingLeft: 30 },
								isWeb && styles.text,
							]}
						>
							businessSettings.general.twoFactorAuth.note
						</I18n>
					</View>
					<FieldBuilder
						label={() => ''}
						name={TWO_FACTOR_AUTH_FIELD}
						type={'buttonsGroup'}
						options={twoFactorAuthOptions}
						disabled={!isActive}
					/>
				</View>
			</View>
			<View style={{ flexDirection: 'row', marginVertical: 30 }}>
				<SolidButtonContainer
					size={isWeb ? 'medium' : 'small'}
					textOptions={{ color: colors.lightPrimary }}
					overrideStyle={[
						styles.cancelButton,
						!isWeb && {
							paddingHorizontal: 22,
							paddingVertical: 10,
						},
					]}
					onPress={onCancel}
				>
					general.cancel
				</SolidButtonContainer>
				<SolidButtonContainer
					size={isWeb ? 'medium' : 'small'}
					disabled={disableSubmit || !isActive}
					overrideStyle={
						!isWeb && { paddingHorizontal: 22, paddingVertical: 10 }
					}
					onPress={() => {
						onUpdate(eventsOptions);
						setDisableSubmit(true);
					}}
				>
					general.save
				</SolidButtonContainer>
			</View>
		</ScrollView>
	);
};

const styles = StyleSheet.create({
	container: {
		paddingHorizontal: 20,
		flex: Platform.OS === 'web' ? 1 : undefined,
		justifyContent: 'space-between',
		height:
			Platform.OS === 'web'
				? '100%'
				: Dimensions.get('screen').height - 300,
	},
	body: {
		flexGrow: 1,
	},
	row: {
		flexDirection: 'row-reverse',
		alignItems: 'center',
		marginTop: 12
	},
	mobileRow: {
		flexDirection: 'column',
	},
	text: {
		width: 420,
	},
	cancelButton: {
		marginHorizontal: 10,
		backgroundColor: colors.white,
		borderColor: colors.lightPrimary,
		borderWidth: 1,
	},
});
